(function () {
  /**
   * Define the logic for the <text-buttons> custom element
   */
  class TextButtons extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Lifecycle method: Called when the element is added to the DOM
     */
    connectedCallback() {
      // Use Event Delegation: attach one listener to the host element
      this.addEventListener('click', (e) => this.handleAnchorClick(e));
    }

    /**
     * Logic to handle smooth scrolling for anchor links
     * @param {Event} e - The click event
     */
    handleAnchorClick(e) {
      // Find the closest button with the required class
      const btn = e.target.closest('.text__btn');

      // Exit if not a button or doesn't have an href
      if (!btn || !btn.hasAttribute('href')) return;

      const href = btn.getAttribute('href');

      // Check if the link is an internal ID anchor
      if (href.startsWith('#')) {
        const targetId = href.substring(1); // Remove the '#'
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          e.preventDefault(); // Prevent default instant jump

          // Perform smooth scroll
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          // Update URL hash without jumping (optional)
          window.history.pushState(null, null, `#${targetId}`);
        } else {
          console.warn(`Target element #${targetId} not found.`);
        }
      }
    }
  }

  /**
   * Check if the custom element exists in the DOM before defining it
   */
  if (document.querySelector('text-buttons')) {
    // Register the custom element if it's found
    if (!customElements.get('text-buttons')) {
      customElements.define('text-buttons', TextButtons);
    }
  }
})();